import gql from 'graphql-tag'

export const GET_SETTING_QUERY = gql`
	query workerRemindersQuery {
		workerReminders {
			id
			enabled
			frequency
			reminderType
			channels
			smsOptBackInInstructions
			reminder {
				name
				description
				fixedText
				isFixed
				availableFrequencies
				channels
			}
		}
	}
`

export const UPDATE_SETTING_MUTATION = gql`
	mutation updateWorkerReminderMutation($id: String, $enabled: Boolean!, $frequency: ReminderFrequencyEnum, $channels: JSON!) {
		updateWorkerReminder(id: $id, enabled: $enabled, frequency: $frequency, channels: $channels) {
			id
		}
	}
`
